export const HOUSE = 'house';
export const CONDOMINIUM = 'condominium';

export interface UCAddress {
  id: string,
  name: string,
}
